import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NotAuthGuard implements CanActivate {
  token$ = this.authService.token$;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.token$.pipe(
      map((t) => {
        if(!t || !t.exp) return true;
        if (new Date() >= new Date(t.exp * 1000)) return true;

        const url = new URL(state.url, window.location.origin);
        const tokenParam = url.searchParams.get('ekapyIntegrationSystemDtToken');
        const usernameParam = url.searchParams.get('username');

        if (tokenParam && usernameParam) {
          this.authService.logout();
        }

        this.router.navigate(['home']);
        return false;
      })
    );
  }
}
